import axios from "axios";
import {
  ACTIVATE_AUTOMATIC_ALERT_SYSTEM_ERROR,
  ACTIVATE_AUTOMATIC_ALERT_SYSTEM_REQUEST,
  ACTIVATE_AUTOMATIC_ALERT_SYSTEM_SUCCESS,
  DELETE_ALERT_STRATEGY_ERROR,
  DELETE_ALERT_STRATEGY_REQUEST,
  DELETE_ALERT_STRATEGY_SUCCESS,
  GET_ALERT_STATUS_ERROR,
  GET_ALERT_STATUS_REQUEST,
  GET_ALERT_STATUS_SUCCESS,
  GET_ALERT_STRATEGIES_ERROR,
  GET_ALERT_STRATEGIES_REQUEST,
  GET_ALERT_STRATEGIES_SUCCESS,
  GET_PREVIOUS_EMAILS_ERROR,
  GET_PREVIOUS_EMAILS_REQUEST,
  GET_PREVIOUS_EMAILS_SUCCESS,
  GET_TELEGRAM_BOT_TOKEN_ERROR,
  GET_TELEGRAM_BOT_TOKEN_REQUEST,
  GET_TELEGRAM_BOT_TOKEN_SUCCESS,
  GET_TRACKED_SIGNALS_ERROR,
  GET_TRACKED_SIGNALS_REQUEST,
  GET_TRACKED_SIGNALS_SUCCESS,
  SET_TRACK_SIGNALS_SUCCESS,
  TRACK_SIGNALS_ERROR,
  TRACK_SIGNALS_REQUEST,
  UPDATE_ALERT_STRATEGY_ERROR,
  UPDATE_ALERT_STRATEGY_REQUEST,
  UPDATE_ALERT_STRATEGY_SUCCESS,
} from "./consts";
import { notify } from "../../utility/Toastify/toastify";
import alert from "../../components/alerts/Alert";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";

export const setTrackSignal =
  (
    email,
    user,
    category,
    name,
    subcategory,
    retryCount = 0,
    currentPath = window.location.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: TRACK_SIGNALS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      email,
      user,
      request_type: "set_signal_to_track",
      category,
      subcategory,
      name,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: SET_TRACK_SIGNALS_SUCCESS, payload: res?.data });
        notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            setTrackSignal(
              email,
              user,
              category,
              name,
              subcategory,
              retryCount + 1,
            ),
          TRACK_SIGNALS_ERROR,
          user,
          email,
          formatTelegramLog("set_signal_to_track", data, url),
          0,
          currentPath,
        );
      });
  };

export const activeAutomaticAlertSystem =
  (
    email,
    user,
    prefered_alert_time,
    alert_frequency,
    asset_in_danger_watch,
    risk_taking_amount,
    start_time_interval_active,
    end_time_interval_active,
    balance_thresh,
    retryCount = 0,
    currentPath = window.location.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: ACTIVATE_AUTOMATIC_ALERT_SYSTEM_REQUEST });
    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "activate_automatic_alert_system",
      prefered_alert_time,
      alert_frequency,
      asset_in_danger_watch,
      risk_taking_amount,
      start_time_interval_active,
      end_time_interval_active,
      balance_thresh,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: ACTIVATE_AUTOMATIC_ALERT_SYSTEM_SUCCESS,
          payload: res?.data,
        });
        dispatch(getAlertStatus(email, user));
        alert(null, res.data.MESSAGE, "success", {
          cancel: "Ok",
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            activeAutomaticAlertSystem(
              email,
              user,
              prefered_alert_time,
              alert_frequency,
              asset_in_danger_watch,
              risk_taking_amount,
              start_time_interval_active,
              end_time_interval_active,
              balance_thresh,
              retryCount + 1,
            ),
          ACTIVATE_AUTOMATIC_ALERT_SYSTEM_ERROR,
          user,
          email,
          formatTelegramLog("activate_automatic_alert_system", data, url),
          0,
          currentPath,
        );
      });
  };
export const disableTrackSignal =
  (
    email,
    user,
    feature_key,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: TRACK_SIGNALS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "disable_signal_to_track",
      feature_key,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: SET_TRACK_SIGNALS_SUCCESS, payload: res?.data });
        notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => disableTrackSignal(email, user, feature_key, retryCount + 1),
          TRACK_SIGNALS_ERROR,
          user,
          email,
          formatTelegramLog("disable_signal_to_track", data, url),
          0,
          currentPath,
        );
      });
  };
export const getTrackedSignal =
  (email, user, retryCount = 0, currentPath = window.location.href) =>
  async (dispatch) => {
    dispatch({ type: GET_TRACKED_SIGNALS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "get_signals_to_track_list",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_TRACKED_SIGNALS_SUCCESS, payload: res?.data });
        notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getTrackedSignal(email, user, retryCount + 1),
          GET_TRACKED_SIGNALS_ERROR,
          user,
          email,
          formatTelegramLog("get_signals_to_track_list", data, url),
          0,
          currentPath,
        );
      });
  };
export const getAlertStatus =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_ALERT_STATUS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "get_alert_system_status",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_ALERT_STATUS_SUCCESS, payload: res?.data });
        notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getAlertStatus(email, user, retryCount + 1),
          GET_ALERT_STATUS_ERROR,
          user,
          email,
          formatTelegramLog("get_alert_system_status", data, url),
          0,
          currentPath,
        );
      });
  };

export const deactivateAutomaticAlert =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: ACTIVATE_AUTOMATIC_ALERT_SYSTEM_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "deactivate_automatic_alert_system",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: ACTIVATE_AUTOMATIC_ALERT_SYSTEM_SUCCESS,
          payload: res?.data,
        });
        dispatch(getAlertStatus(email, user));
        alert(null, res.data.MESSAGE, "success", {
          cancel: "Ok",
        });
        // notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => deactivateAutomaticAlert(email, user, retryCount + 1),
          ACTIVATE_AUTOMATIC_ALERT_SYSTEM_ERROR,
          user,
          email,
          formatTelegramLog("deactivate_automatic_alert_system", data, url),
          0,
          currentPath,
        );
      });
  };
export const getPreviousEmails =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_TRACKED_SIGNALS_REQUEST });
    dispatch({ type: GET_PREVIOUS_EMAILS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "alert_system",
      user,
      email,
      request_type: "get_latest_alert_emails",
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_PREVIOUS_EMAILS_SUCCESS, payload: res?.data });
        notify(res.data.MESSAGE, "success");
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getPreviousEmails(email, user, retryCount + 1),
          GET_PREVIOUS_EMAILS_ERROR,
          user,
          email,
          formatTelegramLog("get_latest_alert_emails", data, url),
          0,
          currentPath,
        );
      });
  };

export const getTelegramBotToken =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_TELEGRAM_BOT_TOKEN_REQUEST });

    const url =
      "https://0znr1xesf9.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      operation_mode: "login",
      email,
      user,
    };

    await axios
      .post(url, data)
      .then((res) => {
        const {
          accessToken: { jwtToken: token },
        } = res?.data;
        dispatch({ type: GET_TELEGRAM_BOT_TOKEN_SUCCESS, payload: token });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getTelegramBotToken(email, user, retryCount + 1),
          GET_TELEGRAM_BOT_TOKEN_ERROR,
          user,
          email,
          formatTelegramLog("login", data, url),
          0,
          currentPath,
        );
      });
  };

export const getAlertStrategies =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_ALERT_STRATEGIES_REQUEST });

    const data = {
      user,
      email,
      platform_mode: "alert_system",
      request_type: "get_alert_strategies",
    };
    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({ type: GET_ALERT_STRATEGIES_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getAlertStrategies(user, email, retryCount + 1),
          GET_ALERT_STRATEGIES_ERROR,
          user,
          email,
          formatTelegramLog("get_alert_strategies", data, url),
          0,
          currentPath,
        );
      });
  };

export const updateAlertStrategy =
  (
    user,
    email,
    alert_strategies,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: UPDATE_ALERT_STRATEGY_REQUEST });

    const data = {
      email,
      user,
      platform_mode: "alert_system",
      request_type: "update_alert_strategy",
      alert_strategies,
    };

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        // console.log(res?.data);
        dispatch({ type: UPDATE_ALERT_STRATEGY_SUCCESS });
        dispatch(getAlertStrategies(user, email));
        alert(null, "Successfully updated.", "success", {
          cancel: "Ok",
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            updateAlertStrategy(user, email, alert_strategies, retryCount + 1),
          UPDATE_ALERT_STRATEGY_ERROR,
          user,
          email,
          formatTelegramLog("update_alert_strategy", data, url),
          0,
          currentPath,
        );
      });
  };

export const deleteAlertStrategy =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: DELETE_ALERT_STRATEGY_REQUEST });

    const data = {
      email,
      user,
      platform_mode: "alert_system",
      request_type: "delete_alert_strategy",
    };

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";

    await axios
      .post(url, data)
      .then((res) => {
        console.log(res?.data);
        dispatch({ type: DELETE_ALERT_STRATEGY_SUCCESS });
        dispatch(getAlertStrategies(user, email));
        alert(null, "Successfully updated.", "success", {
          cancel: "Ok",
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => deleteAlertStrategy(user, email, retryCount + 1),
          DELETE_ALERT_STRATEGY_ERROR,
          user,
          email,
          formatTelegramLog("delete_alert_strategy", data, url),
          0,
          currentPath,
        );
      });
  };
